import BaseAPI from './base';
import { httpService } from '@espacePro/data-provider/services/HttpService';

class RecoveryPointsAPI extends BaseAPI {
  getPointsList(
    date: string,
    latitude: string,
    longitude: string,
    radius: string,
    limit: string,
    page: string,
    sort: string,
    weekdays: string,
    departmentIds: string,
    locationIds: string
  ) {
    const pointsQueryParams = new URLSearchParams({
      date,
      latitude: latitude || '',
      longitude: longitude || '',
      radius: radius || '',
      limit,
      page,
      sort,
      weekdays,
      department_ids: departmentIds,
      location_ids: locationIds,
    });
    return this.get('/api/web/v1/recovery_points/stages', pointsQueryParams);
  }

  getPoint(id: string, includeLocation: boolean = false) {
    const params = includeLocation ? { include_location: 'true' } : {};
    return this.get(`/api/web/v1/recovery_points/stages/${id}`, params);
  }

  getLocationsList(latitude: string, longitude: string, sort: string) {
    const locationsQueryParams = new URLSearchParams({
      latitude,
      longitude,
      sort,
    });
    return this.get('/api/web/v1/recovery_points/locations', locationsQueryParams);
  }

  getLocation(id: string) {
    return this.get(`/api/web/v1/recovery_points/locations/${id}`, {});
  }

  searchReservations(page: number, limit: number, query: string) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      query,
    });
    return this.get('/api/web/v1/pro/recovery_points/reservations', params);
  }

  createPointReservation(stageId: string) {
    return this.post(`/api/web/v1/student/recovery_points/reservations`, { stage_id: stageId });
  }

  createPointReservationForStudent(stageId: string, studentId: string) {
    return this.post(`/api/web/v1/pro/recovery_points/reservations`, {
      stage_id: stageId,
      student_id: studentId,
    });
  }

  getReservations() {
    return this.get('/api/web/v1/student/recovery_points/reservations', {});
  }

  getCommissionsList(page: number, limit: number) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    return this.get('/api/web/v1/pro/recovery_points/reservations/commissions', params);
  }

  getInvoicesList(page: number, limit: number) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    return this.get('/api/web/v1/pro/recovery_points/reservations/invoices', params);
  }

  validatePointReservation(reservationId: string) {
    return this.put(
      `/api/web/v1/student/recovery_points/reservations/${reservationId}/validate`,
      {}
    );
  }

  validatePromoCode(reservationId: string, code: string) {
    return this.put(`/api/web/v1/student/recovery_points/reservations/${reservationId}/promo`, {
      code,
    });
  }

  createInvoice(file, number) {
    const formData = new FormData();
    formData.append('file', file);
    if (number) {
      formData.append('number', number);
    }

    return httpService.post('/api/web/v1/pro/recovery_points/reservations/invoices', formData, {
      contentType: 'multipart/form-data',
    });
  }

  getReferralLink() {
    return this.get('/api/web/v1/pro/recovery_points/reservations/referral', {});
  }
}

export default new RecoveryPointsAPI();
